import React from 'react';
import { Box } from '@mui/material';

type GroupOptionLabelProps = {
  name: string;
  validContactCount?: number;
  joinCampaignCount?: number;
};

export const GroupOptionLabel: React.FC<GroupOptionLabelProps> = ({
  name,
  validContactCount,
  joinCampaignCount,
}) => (
  <>
    {name}
    {validContactCount !== undefined && (
      <>
        {' '}
        <Box component="span" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
          {formatGroupContactCountSuffix(validContactCount, joinCampaignCount)}
        </Box>
      </>
    )}
  </>
);

/** Join campaigns are mentioned only when the group has any, as in the Contact Groups table. */
export const formatGroupContactCountSuffix = (validContactCount: number, joinCampaignCount = 0) =>
  joinCampaignCount > 0
    ? `(${validContactCount} contacts, ${joinCampaignCount} join ${joinCampaignCount === 1 ? 'campaign' : 'campaigns'})`
    : `(${validContactCount} contacts)`;
